// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultsDisseminationComponent = ({
    item,
    theme = 'teal',
    wrap = false,
}) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsDisseminationDetails {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ResultsDisseminationDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const format = useFormat();

    // ///////////////////
    // DATA
    // ///////////////////

    const {
        Publication_Title__c,
        Year__c,
        Publisher__c,
        URL__c,
        Author__c,
        DOI__c,
    } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[
                Publication_Title__c,
                Year__c,
                Publisher__c,
                URL__c,
                Author__c,
                DOI__c,
            ].some(x => x) && (
                <Card.CardContentPairBox>
                    {Publication_Title__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Publication_Title__c'
                                ),
                                value: Publication_Title__c,
                            }}
                        />
                    )}

                    {Year__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Year__c___Dissemination'
                                ),
                                value: format.year(Year__c),
                            }}
                        />
                    )}

                    {Publisher__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Publisher__c'
                                ),
                                value: Publisher__c,
                            }}
                        />
                    )}

                    {URL__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.URL__c'
                                ),
                                value: URL__c,
                            }}
                        />
                    )}

                    {Author__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Author__c'
                                ),
                                value: Author__c,
                            }}
                        />
                    )}

                    {DOI__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.DOI__c'
                                ),
                                value: DOI__c,
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}
        </>
    );
};

ResultsDisseminationComponent.propTypes = {};

ResultsDisseminationComponent.defaultProps = {};

export { ResultsDisseminationDetails };
export default ResultsDisseminationComponent;
